/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateEmailMarkAllAsRead } from '../../axios/candidateEmailMarkAllAsRead'
import type {
	CandidateEmailMarkAllAsReadError,
	CandidateEmailMarkAllAsReadPathParams,
	CandidateEmailMarkAllAsReadResponse,
} from '../../types/CandidateEmailMarkAllAsRead'

export const candidateEmailMarkAllAsReadMutationKey = () =>
	[{ url: '/candidates/:candidateId/emails/read-all' }] as const

export type CandidateEmailMarkAllAsReadMutationKey = ReturnType<typeof candidateEmailMarkAllAsReadMutationKey>

export type CandidateEmailMarkAllAsReadVariables = {
	candidateId: CandidateEmailMarkAllAsReadPathParams['candidateId']
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateEmailController.php CandidateEmailController::markAllAsRead */
export function useCandidateEmailMarkAllAsRead<TContext = unknown>(
	options?: UseMutationOptions<
		CandidateEmailMarkAllAsReadResponse,
		AxiosError<CandidateEmailMarkAllAsReadError>,
		CandidateEmailMarkAllAsReadVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: candidateEmailMarkAllAsReadMutationKey(),
		mutationFn: ({ candidateId }: CandidateEmailMarkAllAsReadVariables) =>
			candidateEmailMarkAllAsRead(candidateId, config).then(res => res.data),
		...options,
	})
}
